import type { ExternalLayer } from 'hooks/externalLayer/types';
import type { InternalLayer } from 'hooks/internalLayer/types';
import type { LayerFolderItemDto } from 'hooks/layerNode/types';

import { isExternalLayerInCurrentScope } from './isExternalLayerInCurrentScope';

/**
 * Catalog rows arrive as a union with no discriminant, so the external-only
 * fields are what tell the two apart.
 */
export function isExternalLayer(
  layer: ExternalLayer | InternalLayer
): layer is ExternalLayer {
  return (
    'arcgisItemId' in layer || 'serviceUrl' in layer || 'itemType' in layer
  );
}

export function isLayerItemInCurrentScope(
  item: LayerFolderItemDto,
  incidentFilterId: string | null | undefined
): boolean {
  // Internal layers are not dual-scoped the same way; keep them all.
  if (!isExternalLayer(item.layer)) return true;
  return isExternalLayerInCurrentScope(item.layer, incidentFilterId);
}
